import { Component } from '@angular/core'
import { DefaultRowComponent } from '../default-row/default-row.component'
import { CustomTableService } from '../../service/custom-table.service'

@Component({
    selector: 'app-saved-cart-row',
    templateUrl: './saved-cart-row.component.html',
    styleUrls: ['./saved-cart-row.component.scss'],
    standalone: false
})
export class SavedCartRowComponent extends DefaultRowComponent {
  constructor(private customTableService: CustomTableService) {
    super()
  }

  public get importCompleted(): boolean {
    const id = this.row[this.uid]
    const data = this.customTableService.dataSource[id]
    return data.importStatus === 'COMPLETED'
  }

  public onClick(control: any): void {
    this.customTableService.clicked(control, this.row)
  }
}
